import { cx } from './util';

// Lucide outline icon at a true 1.5px stroke (§2.7). Pass the lucide-react component, not a name,
// so only the icons in use reach the bundle. size: 16 (Console, Workbench) or 20 (Portal).
export default function Icon({ icon: Glyph, size = 16, label, className }) {
  if (!Glyph) return null;
  return (
    <Glyph
      className={cx('ui-icon', className)}
      size={size}
      strokeWidth={1.5}
      absoluteStrokeWidth
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  );
}
